/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".display-functions-panel[_ngcontent-%COMP%]{background-color:#fff;display:flex;flex-direction:column;padding:4px 10px}.display-functions-panel[_ngcontent-%COMP%]   .display-functions-panel__toggle-switch[_ngcontent-%COMP%]{font-size:13px;font-weight:700}.display-functions-panel[_ngcontent-%COMP%]   .display-functions-panel__toggle-switch[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-right:70px}"];
export { styles as styles };
